import React from "react"
import {
    Box,
    MultiMediaDisplay,
    MediaDisplayType,
    UploadCareImageVariant,
} from "@mallardbay/lib-react-components"

import MobileHeaderButtons from "~components/pages/listing/mobile-header-buttons"
import ListingTitle from "~components/pages/listing/listing-title/listing-title"
import { useCurrentListing } from "~components/providers/current-listing-provider"
import ResponsiveBlock from "~components/shared/responsive-block"
import { useUser } from "~config/user-provider"
import type { PublicListingFieldsFragment } from "~graphql/generated/graphql"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import { HEADER_IMAGE_WIDTH } from "~config/constants"

interface Props {
    readonly listing: PublicListingFieldsFragment
}

export default function ListingHeader({ listing }: Props) {
    const styles = useStyles()
    const { isLargerThanTablet } = useTabletMediaQueries()
    const { currentListing } = useCurrentListing()
    const { user } = useUser()

    const isOwner = user ? currentListing.outfitter.owner.id === user.id : false

    const type = isLargerThanTablet
        ? MediaDisplayType.GRID
        : MediaDisplayType.CAROUSEL

    return (
        <>
            <Box style={styles.container}>
                <ResponsiveBlock noPadding={!isLargerThanTablet}>
                    <MultiMediaDisplay
                        type={type}
                        images={listing.photos}
                        imageWidth={HEADER_IMAGE_WIDTH}
                        imageVariant={UploadCareImageVariant.XL_HORIZONTAL}
                        shouldDisableImageHoverFilter
                    />
                </ResponsiveBlock>
                <ListingTitle listing={listing} isOwner={isOwner} />
            </Box>
            <MobileHeaderButtons listingId={listing.id} />
        </>
    )
}

function useStyles() {
    return {
        container: {
            display: "flex",
            width: "100%",
            flexDirection: {
                base: "column",
                md: "column-reverse",
            },
        },
    }
}
